import { render, staticRenderFns } from "./FilterProductButton.vue?vue&type=template&id=3e0853a6"
import script from "./FilterProductButton.vue?vue&type=script&lang=js"
export * from "./FilterProductButton.vue?vue&type=script&lang=js"
import style0 from "./FilterProductButton.vue?vue&type=style&index=0&id=3e0853a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
